import { Box, Container, makeStyles } from '@material-ui/core'
import { theme } from 'config'
import qs from 'query-string'
import { Redirect, useLocation } from 'react-router-dom'
import { ElementWithChildren } from 'types'

const useStyles = makeStyles(() => ({
  root: {
    background: 'linear-gradient(140deg, rgba(24, 47, 117, 1) 0%, rgba(36, 140, 215, 1) 100%)',
    [theme.breakpoints.down('xs')]: {
      padding: '10vh 1vh 10vh 1vh',
      // position: 'absolute',
    },
    padding: '5vh',
    minHeight: '100vh',
  },
}))

export const AuthLayout = ({ children }: ElementWithChildren): JSX.Element => {
  // const { isAuthenticated } = useUser()
  const isAuthenticated = false
  const location = useLocation()

  const { ref } = qs.parse(location.search)
  if (ref) localStorage.setItem('referralCode', String(ref))

  const classes = useStyles()

  return (
    <Box className={classes.root}>
      {isAuthenticated ? <Redirect to="/" /> : <Container>{children}</Container>}
    </Box>
  )
}
